:host {
  display: block;
  font-weight: var(--semantic-typography-font-weight-regular);

  p {
    overflow: inherit;
    margin: 0;
    padding: 0;
    text-overflow: inherit;
    white-space: inherit;
  }

  .font--display {
    @include font--display;
    @include font--bold;
  }

  .font--body-large {
    @include font--body-large;
  }

  .font--body-regular {
    @include font--body-regular;
  }

  .font--body-small {
    @include font--body-small;
  }

  .font--caption,
  .font--caption-bold,
  .font--caption-regular {
    @include font--caption;
  }

  .font--caption-small {
    @include font--caption-small;
  }

  .font--caption-bold,
  .font--bold {
    font-weight: 700 !important;
  }

  .color--default {
    color: var(--semantic-color-text-default);
  }

  .color--subtle {
    color: var(--semantic-color-text-subtle);
  }

  .color--subtlest {
    color: var(--semantic-color-text-subtlest);
  }

  .color--inverse {
    color: var(--semantic-color-text-inverse);
  }

  .color--accent {
    color: var(--semantic-color-text-accent-body);
  }

  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: normal;
    white-space: nowrap;
  }
}

:host([alignment='left']) p {
  text-align: left;
}

:host([alignment='center']) p {
  text-align: center;
}

:host([alignment='right']) p {
  justify-content: flex-end;
  text-align: right;
}

:host([is-flow-rendition='true']) {
  .font--body-regular {
    @include media-header('from-lg') {
      line-height: var-rem(--semantic-typography-line-height-xs);
    }
  }

  .font--body-small {
    @include media-header('from-lg') {
      line-height: var-rem(--semantic-typography-line-height-xs);
    }

    font-size: var-rem(--semantic-typography-font-size-2sm);
    line-height: var-rem(--semantic-typography-line-height-2sm);
  }

  .font--caption {
    @include media-header('from-lg') {
      font-size: var-rem(--semantic-typography-font-size-2sm);
      line-height: var-rem(--semantic-typography-line-height-xs);
    }

    font-size: var-rem(--semantic-typography-font-size-sm);
    line-height: var-rem(--semantic-typography-line-height-sm);
  }

  .font--caption-bold {
    @include media-header('from-lg') {
      font-size: var-rem(--semantic-typography-font-size-2sm);
      line-height: var-rem(--semantic-typography-line-height-xs);
    }

    font-size: var-rem(--semantic-typography-font-size-sm);
    line-height: var-rem(--semantic-typography-line-height-sm);
  }

  .font--caption-small {
    @include media-header('from-lg') {
      font-size: var-rem(--semantic-typography-font-size-2xs);
      line-height: var-rem(--semantic-typography-line-height-2xs);
    }

    font-size: var-rem(--semantic-typography-font-size-xs);
    line-height: var-rem(--semantic-typography-line-height-xs);
  }
}

/* Flow rendition convertion
.text-flow--body = font--body-regular
.text-flow---detail = font--body-small
.text-flow---button = font--body-small
.text-flow---legal = font--caption-small
.text-flow---label = font--body-regular
.text-flow---action = font--body-small
.text-flow---hyperlink = font--body-small + class: text-decoration--underline
.text-flow---promo = font--caption-bold
.text-flow---promo-price = font--caption
*/
